import React from 'react'
import { useSelector } from 'react-redux'
import { FlexContainer, removeStringB64, convertBlobToBase64 } from 'heliocor-ui'
import 'styled-components/macro'

import { VideoCamera } from './video/VideoSelfie'
import ImageSelfie from './image/ImageSelfie'
import { CameraLoader, OuterBox } from './Camera.elements'
import { imgDimensions } from './Camera.options'


const VIEWS = {
    IMAGE_SELFIE: 'IMAGE_SELFIE',
    VIDEO_SELFIE: 'VIDEO_SELFIE',
}

const CameraComponent = ({ documentConfig, handleUpload, isVideoSelfie }) => {

    const cafeStatus = useSelector(state => state.general.cafeStatus)
    const imageSelfieInstructions = useSelector(state => state?.settings?.imageSelfieInstructions)
    const statementRecordingTime = useSelector(state => state?.settings?.statementRecordingTime)
    const statementCheckMessage = useSelector(state => state?.settings?.statementCheckMessage)

    const currentView = isVideoSelfie ? VIEWS.VIDEO_SELFIE : VIEWS.IMAGE_SELFIE;
    
    const formatAndSendImage = (img) => {
        const formattedImage = removeStringB64(img)
        handleUpload({image: formattedImage, isCore: documentConfig.core, selected: documentConfig})
    }

    const convertAndSendVideo = async (blob) => {
        let videoB64 = await convertBlobToBase64(blob)
        videoB64 = removeStringB64(videoB64)
        handleUpload({image: videoB64, fileName: "video_selfie", isCore: documentConfig.core, selected: documentConfig})
    }

    if (cafeStatus === 'LOADING') return <CameraLoader height={imgDimensions.height} />

    return (
        <FlexContainer column justifyContent='center' alignItems='center'>
            <OuterBox height={imgDimensions.height} color='transparent'>
                {currentView === VIEWS.VIDEO_SELFIE && (
                    <VideoCamera 
                        statementCheck={statementCheckMessage}
                        statementRecordingTime={statementRecordingTime} 
                        onSend={convertAndSendVideo} 
                    />
                )}
                {currentView === VIEWS.IMAGE_SELFIE && (
                    <ImageSelfie 
                        instructions={imageSelfieInstructions}
                        onImageUpload={formatAndSendImage} 
                    />
                )}
            </OuterBox>
        </FlexContainer>
    );
}

export { CameraComponent }